import { http } from '@/utils/http';
import qs from 'qs';
// base-info
export function getBaseinfo(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=base-info');
}

// 新闻列表
export function getNewslist(voteName: string, page: number) {
  return http.get('/vote/' + voteName + '/controller.php?enews=news-list', {
    params: { page },
  });
}
// 新闻列表接口·新
export function fetchNewslist(page: number, classId: number) {
  return http.get(
    `/vote/public/controller.php?enews=news-list&page=${page}&classId=${classId}`,
  );
}
interface IVoteListOption {
  voteName: string;
  page?: number;
  type?: any;
  search?: string | number;
  teamType?: any;
}
// 投票列表页
export function getVoteList({
  voteName,
  page,
  type,
  search,
  teamType,
}: IVoteListOption) {
  return http.get('/vote/' + voteName + '/controller.php?enews=vote-list', {
    params: { page, type, search, teamType },
  });
}

// 活动规则
export function getRules(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=rules');
}

// 判断今天这个id是否已经滑动验证过
export function needSmoothCheck(
  voteName: string,
  data: { udid: string | number | undefined },
) {
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=needSmoothCheck',
    data,
  );
}

// 活动投票
export function vote(
  voteName: string,
  data: {
    id: number | string;
    udid?: any;
    appkey?: any;
    code?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  const qsData = qs.stringify(data);
  return http.post('/vote/' + voteName + '/controller.php?enews=vote', qsData);
}

// 获取详情页面
export function getcontent(voteName: string, id: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=getcontent&id=' + id,
  );
}
// 获取详情页面
export function detail(voteName: string, id: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=detail&id=' + id,
  );
}
// 报名页面提交报名接口
export function save(voteName: string, data: any) {
  const qsData = qs.stringify(data);
  return http.post('/vote/' + voteName + '/controller.php?enews=save', qsData);
}

// 获取unionId接口
export function getUnionId(data: any) {
  console.log('enter api', data);
  const qsData = qs.stringify(data);
  return http.post('/vote/public/controller.php?enews=unionid', qsData);
}
// 获取unionId接口
export function getBYDUnionId(data: any) {
  console.log('enter api', data);
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/public/controller.php?enews=unionid&token=cq_byd',
    qsData,
  );
}
// 获取unionId接口
export function getZHBFUnionId(data: any) {
  console.log('enter api', data);
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/public/controller.php?enews=unionid&token=cq_zhbf',
    qsData,
  );
}

// 获取微信js sdk
export function wxSdkInfo(jssdkurl: any) {
  return http.get('/vote/public/controller.php?enews=jssdk', {
    params: { ...jssdkurl },
  });
}
// app获取用户接口
export function getUserInfo(voteName: string) {
  return http.get('/vote/' + voteName + '/controller.php?enews=user-info');
}

// 支付宝支付
export function AliPay(voteName: string, data: any) {
  const qsData = qs.stringify(data);
  return http.post('/vote/' + voteName + '/pay.php', qsData);
}
// 访问数据量接口;（所有活动通用;）
export function visitOne(id: number | string) {
  return http.get('/e/public/ViewClick/?classid=9&id=' + id + '&addclick=1');
}
export function visitTwo(id: number | string) {
  return http.get('/e/public/onclick/?enews=donews&classid=9&id=' + id);
}

// 服务端获取oss签名
export function getOssSignature() {
  return http.get(
    '/vote/public/common/controller.php?enews=getOssToken&tableId=1',
  );
}
// 服务端获取oss签名（新）-2022.8.26 by tyh
export function getNewOssSignature() {
  return http.get(process.env.VUE_APP_OSS_NEW);
}

// 服务端获取oss签名（最新）-2022.8.26 by tyh
export function NewOssSignature() {
  return http.get(process.env.VUE_APP_OSS_NEWEST);
}

// 详情页面接口新
export function detailModel(voteName: string, id: any) {
  return http.get(
    `/vote/${voteName}/controller.php?enews=detail-model&id=${id}`,
  );
}

// 微信是否绑定手机号
export function unionIdIsBind(data: any) {
  return http.post(`/v1/user/unionIdIsBind`, qs.stringify(data));
}

// 获取短信验证码
export function webSendMsg(data: any) {
  const qsData = qs.stringify(data);
  return http.post('/v1/common/webSendMsg', qsData);
}

// 短信code验证
export function valisendMsg(data: any) {
  const qsData = qs.stringify(data);
  return http.post('/v1/common/valisendMsg', qsData);
}
// 绑定上游手机号
export function bind3rdParty(data: any) {
  const qsData = qs.stringify(data);
  return http.post('/v1/user/bind3rdParty ', qsData);
}
// 新闻通用接口  新
export function getNews(page: any, category: any, classId: any) {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
}
